module.exports = __webpack_public_path__ + "img/visore.97fa206b.png";